import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

@Component({ name: "JobProfileSubmit" })
export default class JobProfileSubmit extends Vue {
    public isLoadingForm: boolean = false;
    public isSuccess: boolean = false;
    public formData: any = { province: null, dealerPointCode: null, workingArea: null };
    public fileName: string = null;
    public zones: any = [];
    public dealerJobOfferWorkingAreas: any = [];
    public dealerJobOfferOfferTypes: any = [];
    public dealer: any = {};
    public dealerPoints: any[] = [];
    public validationErrors: any[] = [];
    public dealerPoint: any = {};
    public jobOfferDetail: any = {};

    @Prop() readonly recaptchaSiteKey: string;
    @Prop() readonly offerIdMaster: string;
    @Prop() readonly dealerCode: string;
    @Prop() readonly dealerPointCode: string;

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        await Promise.all([this.getData(), this.getDealerJobOfferFormList()]);

        if (this.$route.name === "JobProfileSubmit" || this.$route.name === "JobFreeProfileSubmit") {
            document.body.classList.add("overflow");
        }
    }

    public mounted() {
        this.$nextTick(x => {
            document.querySelectorAll('a[href^="#"]').forEach(anchor => {
                anchor.addEventListener('click', function (e) {
                    e.preventDefault();

                    const targetElement = <any>document.querySelector("#SectionSpontaneousChanting");
                    const offset = 200; // Imposta l'offset

                    window.scrollTo({
                        top: targetElement.offsetTop - offset,
                        behavior: 'smooth'
                    });
                });
            });
        });
    }

    public async getData() {
        this.formData.offerIdMaster = this.offerIdMaster;
        this.formData.dealerPointCode = this.dealerPointCode;

        if (this.$route.name === "JobProfileSubmit" || this.offerIdMaster) {
            const response = (await Axios.post(this.routes.WorkWithUs_GetJobOfferData, { offerIdMaster: this.offerIdMaster })).data;
            this.dealer = response.dealer;
            this.dealerPoint = response.dealerPoint;
            this.jobOfferDetail = response.dealerJobOffer;

            this.formData.offerIdMaster = this.jobOfferDetail.idMaster;
            this.formData.dealerPointCode = this.jobOfferDetail.dealerPointCode;
        } else if (this.$route.name === "JobFreeProfileSubmit") {
            const response = (await Axios.post(this.routes.Profile_GetZones)).data;
            this.zones = response;
        } else if (!this.dealerPointCode) {
            const result = (await Axios.post(this.routes.Dealer_GetDealerPointsByDealerCode, { dealerCode: this.dealerCode })).data;
            this.dealerPoints = result;

            if (this.dealerPoints.length === 1) {
                this.formData.dealerPointCode = this.dealerPoints[0].code;
            }
        }

        this.formData.dealerPointCode = !this.formData.dealerPointCode ? null : this.formData.dealerPointCode;
    }

    public async getDealerPoints() {
        this.formData.dealerPointCode = null;
        this.dealerPoints = [];
        if (this.formData.province) {
            const response = (await Axios.post(this.routes.Dealer_GetDealerPointsByProvince, this.formData)).data;
            this.dealerPoints = response.dealerPoints;
        }
    }

    public async getDealerJobOfferFormList() {
        const response = (await Axios.post(this.routes.WorkWithUs_GetDealerJobOfferFormList)).data;
        this.dealerJobOfferWorkingAreas = response.dealerJobOfferWorkingAreas;
        this.dealerJobOfferOfferTypes = response.dealerJobOfferOfferTypes;
    }

    public setRegistrationFileName() {
        let curriculumVitae = (<any>this).$refs.curriculumVitae;

        this.fileName = null;

        if (curriculumVitae.files.length !== 0 && curriculumVitae.files[0].name) {
            this.fileName = curriculumVitae.files[0].name;
        }
    }

    public async submitForm() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoadingForm = true;

        let multipartData = new FormData();
        multipartData.append("curriculumVitae", (<any>this).$refs.curriculumVitae.files[0]);

        for (const key in this.formData) {
            if (Object.prototype.hasOwnProperty.call(this.formData, key)) {
                if (this.formData[key]) {
                    multipartData.append(key, this.formData[key]);
                }
            }
        }

        (<any>window).grecaptcha.enterprise.ready(async () => {
            const token = await (<any>window).grecaptcha.enterprise.execute(this.recaptchaSiteKey, { action: 'Submit' });

            try {
                await Axios.post(this.routes.WorkWithUs_JobProfileSubmit, multipartData, { headers: { "RecaptchaVerificationToken": token, "Content-Type": "multipart/form-data" } });

                this.isSuccess = true;

                GTagHelper.sendEvent("form_submit", "work_with_us");

                if (!this.$route.name) {
                    const targetElement = <any>document.querySelector("#SectionSpontaneousChanting");
                    const offset = 100; // Imposta l'offset

                    window.scrollTo({
                        top: targetElement.offsetTop - offset,
                        behavior: 'smooth'
                    });
                }
            } catch (error) {
                if (error.response && error.response.status === 400) {
                    this.validationErrors = FormHelper.getValidationErrors(error.response.data);
                }
            }

            this.isLoadingForm = false;
        });
    }

    public profiling(profiling: boolean) {
        this.formData.isProfiling = profiling;
    }

    public marketing(marketing: boolean) {
        this.formData.isMarketing = marketing;
    }

    public marketingChannels(marketingChannels: any) {
        this.formData.marketingChannels = marketingChannels;
    }

    public closeJobProfileSubmit() {
        if (this.$route.name === "JobProfileSubmit" || this.$route.name === "JobFreeProfileSubmit") {
            document.body.classList.remove("overflow");
        }

        if (this.$route.name === "JobProfileSubmit") {
            this.$router.push({ name: "JobOfferDetail", params: { offerIdMaster: this.offerIdMaster } }).catch(() => { });
        } else if (this.$route.name === "JobFreeProfileSubmit") {
            this.$router.push({ name: "WorkWithUsLocator" }).catch(() => { });
        }
    }

    public isValidationError(controlName: string): boolean {
        return FormHelper.isControlValidationError(controlName, this.validationErrors);
    }
}